import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorBoundary from '../components/ErrorBoundary';
export function mountComponent(elementId, pageRenderer) {
    const container = document.getElementById(elementId);
    if (container) {
        const root = createRoot(container);
        root.render(React.createElement(ErrorBoundary, null, pageRenderer()));
    }
}
export function mountComponentWithData(elementId, pageRenderer) {
    const container = document.getElementById(elementId);
    if (!container) {
        throw new Error(`Unable to find container element ${elementId}`);
    }
    const dataElement = container.querySelector('script');
    if (!dataElement) {
        throw new Error(`Unable to load data for component when mounting "{wrapperClassName}"!`);
    }
    const root = createRoot(container);
    const data = JSON.parse(dataElement.innerHTML);
    root.render(React.createElement(ErrorBoundary, null, pageRenderer(data)));
}
